import styled from 'styled-components'
import {lightGray, lightenDarkenColor, white} from '@modifi/colors'

export const HighLightText = styled.span`
  border: 1px solid ${({backgroundColor = lightGray}) => backgroundColor};
  margin-left: 2px;
  margin-right: 2px;
  background: ${({backgroundColor = lightGray}) => lightenDarkenColor(backgroundColor, -10)};
  color: ${white};
`

export const TextWrapper = styled.div`
  display: inline-flex;
  word-break: break-all;
`
